import {
  EEventType,
  IContext,
  TViewChanged,
  TFaqLinkClicked,
  THelpCenterLinkClicked,
  TSendFormSucceed,
  TLinkOwnerClick,
} from '@cian/feedback-form-widget';
import { useEffect } from 'react';

import {
  trackFaqLinkClick,
  trackFeedbackSend,
  trackHelpCenterLinkClick,
  trackLinkOwnerClick,
  trackViewShow,
} from '../tracking';

export function useTracking(widgetContext: IContext) {
  useEffect(() => {
    const handleFaqLinkClick = ({ text }: TFaqLinkClicked[1]) => {
      trackFaqLinkClick(text);
    };
    const handleFeedbackFormSend = ({ topic }: TSendFormSucceed[1]) => {
      trackFeedbackSend(topic);
    };
    const handleViewChanged = ({ view }: TViewChanged[1]) => {
      trackViewShow(view);
    };

    widgetContext.on<TViewChanged>(EEventType.ViewChanged, handleViewChanged);
    widgetContext.on<THelpCenterLinkClicked>(EEventType.HelpCenterLinkClicked, trackHelpCenterLinkClick);
    widgetContext.on<TFaqLinkClicked>(EEventType.FaqLinkClicked, handleFaqLinkClick);
    widgetContext.on<TLinkOwnerClick>(EEventType.LinkOwnerClick, trackLinkOwnerClick);
    widgetContext.on<TSendFormSucceed>(EEventType.SendFormSucceed, handleFeedbackFormSend);

    return () => {
      widgetContext.off<TViewChanged>(EEventType.ViewChanged, handleViewChanged);
      widgetContext.off<THelpCenterLinkClicked>(EEventType.HelpCenterLinkClicked, trackHelpCenterLinkClick);
      widgetContext.off<TFaqLinkClicked>(EEventType.FaqLinkClicked, handleFaqLinkClick);
      widgetContext.off<TLinkOwnerClick>(EEventType.LinkOwnerClick, trackLinkOwnerClick);
      widgetContext.off<TSendFormSucceed>(EEventType.SendFormSucceed, handleFeedbackFormSend);
    };
  }, [widgetContext]);
}
